import React from 'react';
import SharedCards from '../../Shared/SharedCards/SharedCards';
import { aboutValues } from './data';
const Values=()=>{
    return(
        <>
        <SharedCards 
        title="Our values"
        desc="We want you to love working here as much as we do. To inspire our team to be creative, productive, and most importantly – feel valued as employees, we offer endless perks and de-stressors. How fun it is to unwind while at work! "
        list={aboutValues}
        />
        </>
    )
};
export default Values ;